<template>
  <div>
    <div>
      <div class="tlive-create__student--contain">
        <div class="tlive-create__student--choose" @click="showDialog">
          {{
            value.length
              ? $t(
                  'pc_biz_personSpecified',
                  [value.length] /*  已指定{0}人 */
                )
              : $t('pc_biz_hasNoChoseStudents' /* 未选择指定人员 */)
          }}
        </div>
        <span class="tlive-create__tip">
          {{
            $t(
              'pc_biz_designatedWatchTips' /* 指定人员通过分享链接或从“直播广场”观看 */
            )
          }}
        </span>
      </div>
    </div>

    <div class="tlive-create__student--list" v-if="value.length">
      <check-list :data="value">
        <template slot-scope="scope">
          <yxt-tag
            size="small"
            v-for="user in scope.list"
            :key="user.id"
            closable
            type="info"
            @close="deleteUserNames(user.id)"
          >
            <span>
              <yxtbiz-user-name :name="user.fullname" />
            </span>
          </yxt-tag>
        </template>
      </check-list>
    </div>
     <!-- 选择学员 -->
      <yxt-drawer
        :before-close="onStudentBeforeClose"
        :header-border="false"
        :destroy-on-close="true"
        size="960px"
        :visible.sync="dialogVisible"
        v-loading="chooseLoading"
      >
        <yxt-user-selector
          ref="selector"
          :data="value"
          :tabs="tabs"
          :function-code="isGroupOrg ? 'group_task_center' : 'tlive_mgmt_list'"
          :data-permission-code="
            isGroupOrg ? 'task_manage_platform' : 'tlive_mgmt_extent'
          "
          :enableGroupCorp="isGroupOrg"
        ></yxt-user-selector>
        <div slot="footer">
          <yxt-button @click="dialogVisible = false" plain>
            {{ $t('pc_biz_core_btn_cancel' /* 取消 */) }}
          </yxt-button>
          <yxt-button type="primary" @click="getUsers('student')">
            {{ $t('pc_biz_core_btn_determine' /* 确认 */) }}
          </yxt-button>
        </div>
      </yxt-drawer>
  </div>
</template>
<script>
import CheckList from '../components/Scroll';

export default {
  name: 'LiveStudents',
  inject: ['isGroupOrg'],
  props: {
    value: {
      type: Array,
      default: []
    },
    formModel: {
      type: Object,
      default: {}
    }
  },
  components: {
    CheckList
  },
  data() {
    return {
      dialogVisible: false,
      tabs: ['persons', 'userGroup', 'advance', 'import'],
      chooseLoading: false
    };
  },
  methods: {
    showDialog() {
      this.dialogVisible = true;
    },
    onStudentBeforeClose(done) {
      done(false);
    },
    // 选人控件点确定
    getUsers() {
      if (this.chooseLoading) {
        return;
      }
      let refs = this.$refs.selector;
      if (refs.processing) {
        this.$message.warning(
          this.$t('pc_biz_doing' /* 正在进行中，请稍后 */),
        );
        return;
      }
      refs.getSelected().then(result => {
        if (result.length === 0) {
          // 请选择需要添加的人员
          this.$alert(
            this.$t('pc_biz_chooseMember' /* 请选择需要添加的成员 */),
            this.$t('pc_biz_udp_lbl_closeTitle' /* 提示 */),
          );
          return;
        }
        this.chooseLoading = true;
        this.selectUsersCallback(result);
        this.dialogVisible = false;
        return;
      });
    },
    selectUsersCallback(result) {
      let idNames = JSON.parse(JSON.stringify(result, ['id', 'fullname']));
      idNames.forEach((item, i) => {
        if (item.id === this.formModel.teacher[0].id) {
          idNames.splice(i, 1);
        }
      });
      this.$emit('input', idNames);

      this.chooseLoading = false;
    },
    // 删除选择的标签
    deleteUserNames(id) {
      let index = this.value.findIndex(item => item.id === id);
      this.value.splice(index, 1);
      let idNames = JSON.parse(
        JSON.stringify(this.value, ['id', 'fullname']),
      );
      this.$emit('input', idNames);

    }
  }
};
</script>
<style scoped lang="less"></style>
